var _a;
import { appendGiphySDKRequestHeader, getGiphySDKRequestHeaders } from '@giphy/js-util';
export { default as GiphyFetch } from './api';
export { serverUrl, setServerUrl } from './constants';
export { default as FetchError } from './fetch-error';
export * from './option-types';
export { gifPaginator } from './paginator';
export { default as request } from './request';
export * from './result-types';
if (typeof require !== 'undefined') {
    var version = require('../package.json').version;
    // since we have multiple SDKs, we're defining a hieracrchy
    // Fetch API is lowest
    if (!((_a = getGiphySDKRequestHeaders()) === null || _a === void 0 ? void 0 : _a.get("X-GIPHY-SDK-NAME"))) {
        // send headers with library type and version
        appendGiphySDKRequestHeader("X-GIPHY-SDK-NAME", 'FetchAPI');
        appendGiphySDKRequestHeader("X-GIPHY-SDK-VERSION", version);
    }
}
//# sourceMappingURL=index.js.map